import { useQuery } from "@tanstack/react-query";
import { PerpMarketProgram } from "../programs/perp-market";
import type { MarketSymbol } from "../constants";

export const useMarkets = () => {
  // Don't initialize here - let useMarketPriceSync handle initialization with dynamic markets
  // This prevents overwriting the dynamic markets with hardcoded 10 markets
  
  const { data: markets = [], isLoading } = useQuery({
    queryKey: ["markets"],
    queryFn: () => {
      // Just read markets from storage (already initialized by useMarketPriceSync)
      const allMarkets = PerpMarketProgram.getAllMarkets();
      return allMarkets;
    },
    refetchInterval: 5000, // Refetch every 5 seconds
  });

  return {
    markets,
    isLoading,
  };
};

export const useMarket = (symbol: string | undefined) => {
  const { data: market, isLoading } = useQuery({
    queryKey: ["market", symbol],
    queryFn: () => {
      if (!symbol) return null;
      return PerpMarketProgram.getMarket(symbol);
    },
    enabled: !!symbol,
    // Polling disabled - WebSocket (use-oracle-sync.ts) provides real-time price updates
    // This prevents excessive re-renders that cause click handlers to fail
    refetchInterval: false,
  });

  return {
    market,
    isLoading,
  };
};

export const useFundingHistory = (symbol: string, limit = 24) => {
  const { data: history = [], isLoading } = useQuery({
    queryKey: ["funding-history", symbol, limit],
    queryFn: () => {
      return PerpMarketProgram.getFundingHistory(symbol as MarketSymbol, limit);
    },
    refetchInterval: 60000, // Refetch every minute
  });

  return {
    history,
    isLoading,
  };
};

